module App.View

open Elmish
open Elmish.HMR
open Fable.Core
open JsInterop
open Fable.Import
open Model
open Messages
open State

module RV = Fable.Import.ReactVirtualized
module RVS = Fable.Import.ReactVirtualizedSelect

importAll "../scss/main.scss"

open Fable.Helpers.React
open Props

let introText = 
    div [ ]
        [ h4 [] [ unbox "Ordlister på dialekt" ]
          p [] [ unbox """På denne sida kan du finne ordlister frå meir enn hundre dialekter. 
                          Du kan få sjå opptil to dialekter samtidig.  Du kan anten søkje på  dialekt 
                          og få sjå alle orda vi har for dialekta, eller du kan gå vidare og søkje på eit særskilt ord.""" ]
          p [] [ unbox """Ordlistene gjer det mogleg å finne ut korleis ein uttalar ord på ulike stader. 
                          Skal du søkje etter eit særskilt ord, skriv du det inn på nynorsk. Listene inneheld 
                          både nynorskforma, dialektforma, og frekvensen, og du kan sortere kolonnane etter 
                          kvar av dei. Ord som vi ikkje finn i Nynorskordboka, er merkte med koden "+x".""" ]
          p [] [ unbox """Orda i ordlistene kjem frå gamle dialektopptak av samtalar og intervju samla inn ved 
                          universiteta i Oslo, Bergen, Trondheim og Tromsø (UiO, UiB, NTNU og UiT) frå 1950-talet og framover.""" ]
          p [] [ unbox """I opptaka snakkar folk om svært ulike emne, til dømes om det gamle arbeidslivet, 
                          kystkulturen, jordbruket og andre tema frå  by og bygd. Ordutvalet i listene varierer difor 
                          frå stad til stad. Likevel har alle opptaka med dei vanlegaste orda i språket, slike 
                          som ”eg”, ”vere”, ”vart”, ”er”, og ”ikkje”. Det er ikkje sikkert at alle bøyingsformene er 
                          med for kvart ord. Listene er automatisk genererte og er ikkje korrekturlesne.""" ]
          p [] [ unbox """Ordlistene og denne søkjesida er bonusprodukt frå det store LIA-prosjektet, som utviklar 
                          forskingsverktøy og dialektmateriale for språkforskarar. LIA er er eit infrastrukturprosjekt 
                          finansiert av Forskingsrådet. Les meir om  LIA-prosjektet """
                 a [ Href "http://www.tekstlab.uio.no/LIA/"; Target "_blank" ] [ unbox "her" ]
                 unbox """. Søk i ei ordliste frå bokmål til nynorsk """
                 a [ Href "http://tekstlab.uio.no/LIA/dialektordlister/bm_nn.html"; Target "_blank" ] [ unbox "her" ]
                 unbox """.""" ] ]

let view (model: Model) dispatch =
    let dialectSelectProps value msg =
        [ RVS.Props.Placeholder "Velg dialekt..."
          RVS.Props.OnChange (fun record -> 
              let newValue = if isNull record then "" else record?value |> string
              dispatch <| msg newValue)
          RVS.Props.Options model.Dialects
          RVS.Props.Value value ]

    let columns = [
        RV.column [ RV.DataKey "phon"
                    RV.Label "Dialektform"
                    RV.ColumnProps.Width 160 ] []
        RV.column [ RV.DataKey "ort"
                    RV.Label "Nynorskform"
                    RV.ColumnProps.Width 160 ] []
        RV.column [ RV.DataKey "freq"
                    RV.Label "Frekvens"
                    RV.ColumnProps.Width 120 ] []
    ]

    let filterWords words (filter: string) =
        let filteredWords = 
            words |> Array.filter (fun w -> 
                filter.Length = 0 
                || (!!w?ort: string) = filter 
                || (!!w?ort: string) = "+x_" + filter)
        if Array.isEmpty filteredWords then words else filteredWords

    let words1 = filterWords model.Words1 model.WordFilter1
    let words2 = filterWords model.Words2 model.WordFilter2

    span []
         [ nav [ ClassName "navbar" ]
               [ div [ ClassName "container-fluid" ]
                     [ // Brand and toggle get grouped for better mobile display
                       div [ ClassName "navbar-header" ]
                           [ button [ Type "button"
                                      ClassName "navbar-toggle collapsed"
                                      DataToggle "collapse"
                                      // DataTarget "#bs-example-navbar-collapse-1"
                                      AriaExpanded false ]
                                    [ span [ ClassName "sr-only"  ] [ unbox "Toggle navigation" ]
                                      span [ ClassName "icon-bar" ] []
                                      span [ ClassName "icon-bar" ] [] ]

                             a [ ClassName "navbar-brand"
                                 Href "http://tekstlab.uio.no"
                                 Target "_blank" ]
                               [ unbox "Dialektordlister" ] ]
                       div [ ClassName "pull-right" ]
                           [ a [ Href "https://www.forskningsradet.no"; Target "_blank" ]
                               [ img [ Src "http://tekstlab.uio.no/norskiamerika/bilder/FR-200.png"
                                       Style [ MarginTop 10; MarginRight 20 ] ] ]
                             a [ Href "http://www.tekstlab.uio.no/LIA/"; Target "_blank" ]
                               [ img [ Src "https://tekstlab.uio.no/bilder/lia-80.png"
                                       Style [ MarginTop 10 ] ] ] ]
                     ]
               ]
           div [ ClassName "container"; Style [ MinWidth 900 ] ] 
               [ div [ ClassName "row"; Style [ MarginBottom 30 ] ]
                     [ introText ]
                 div [ ClassName "row" ] 
                     [ div [ ClassName "col-xs-2" ]
                           [ com<RVS.VirtualizedSelect, obj, obj>(
                                keyValueList CaseRules.LowerFirst <| 
                                    dialectSelectProps model.SelectedDialectId1 SelectedDialect1Changed
                             ) [] ] 
                       div [ ClassName "col-xs-2" ]
                           [ input [ Type "text"
                                     ClassName "form-control"
                                     Placeholder "Søkeord"
                                     Value model.WordFilter1
                                     OnChange (fun e -> dispatch <| WordFilter1Changed !!e.target?value) ] ]
                       div [ ClassName "col-xs-2" ]
                           [ button [ ClassName "btn btn-default"
                                      Disabled (model.SelectedDialectId1 = "")
                                      OnClick (fun _ -> 
                                        dispatch <| DownloadWordlist1 model.SelectedDialectId1) ]
                                    [ unbox "Last ned" ] ]
                       div [ ClassName "col-xs-2" ]
                           [ com<RVS.VirtualizedSelect, obj, obj>(
                                keyValueList CaseRules.LowerFirst <| 
                                    dialectSelectProps model.SelectedDialectId2 SelectedDialect2Changed
                             ) [] ]
                       div [ ClassName "col-xs-2" ]
                           [ input [ Type "text"
                                     ClassName "form-control"
                                     Placeholder "Søkeord"
                                     Value model.WordFilter2
                                     OnChange (fun e -> dispatch <| WordFilter2Changed !!e.target?value) ] ]
                       div [ ClassName "col-xs-2" ]
                           [ button [ ClassName "btn btn-default"
                                      Disabled (model.SelectedDialectId2 = "")
                                      OnClick (fun _ -> 
                                        dispatch <| DownloadWordlist2 model.SelectedDialectId2) ]
                                    [ unbox "Last ned" ] ]
                     ]
                 div [ ClassName "row"; Style [ MarginTop 30 ] ]
                     [ div [ ClassName "col-xs-6"; Style [ PaddingBottom 15 ] ]
                           [ RV.table [
                                RV.HeaderHeight 50
                                RV.Height 500
                                RV.RowClassName (fun {index = index} ->
                                    if index % 2 = 0 then "even-table-row" else "")
                                RV.RowCount <| Array.length words1
                                RV.RowGetter (fun {index = index} -> Array.get words1 index)
                                RV.RowHeight 20
                                RV.Sort (fun sortArg -> 
                                    let (sa: RV.SortArg) = 
                                        { SortBy = string sortArg?sortBy
                                          SortDirection = string sortArg?sortDirection }
                                    dispatch <| SetWordTableSort1 sa )
                                RV.SortBy model.WordTableSort1.SortBy
                                RV.SortDirection model.WordTableSort1.SortDirection
                                RV.Width 430
                            ] columns ] 
                       div [ ClassName "col-xs-6"; Style [ PaddingBottom 15 ] ]
                           [ RV.table [
                                RV.HeaderHeight 50
                                RV.Height 500
                                RV.RowClassName (fun {index = index} ->
                                    if index % 2 = 0 then "even-table-row" else "")
                                RV.RowCount <| Array.length words2
                                RV.RowGetter (fun {index = index} -> Array.get words2 index)
                                RV.RowHeight 20
                                RV.Sort (fun sortArg -> 
                                    let (sa: RV.SortArg) = 
                                        { SortBy = string sortArg?sortBy
                                          SortDirection = string sortArg?sortDirection }
                                    dispatch <| SetWordTableSort2 sa )
                                RV.SortBy model.WordTableSort2.SortBy
                                RV.SortDirection model.WordTableSort2.SortDirection
                                RV.Width 430
                            ] columns ]
                     ]
               ]
         ]

open Elmish.React
open Elmish.Debug

// App
Program.mkProgram init update view
#if DEBUG
|> Program.withConsoleTrace
|> Program.withHMR
#endif
|> Program.withReact "elmish-app"
#if DEBUG
|> Program.withDebugger
#endif
|> Program.run


// WEBPACK FOOTER //
// src/App.fs